export const helpCenterArticlesConfig = {
  about: {
    href: '/help/about',
    title: 'About',
    slug: 'about',
  },
  faq: {
    href: '/help/faq',
    title: 'FAQ',
    slug: 'faq',
  },
  fairness: {
    href: '/help/fairness',
    title: 'Fairness',
    slug: 'game-fairness',
  },
  terms: {
    href: '/help/terms',
    title: 'Terms & Conditions',
    slug: 'terms-and-conditions',
  },
  antiMoneyLaundering: {
    href: '/help/anti-money-laundering',
    title: 'Anti-Money Laundering',
    slug: 'anti-money-laundering',
  },
  cookies: {
    href: '/help/cookies',
    title: 'Cookies Policy',
    slug: 'cookies-policy',
  },
  privacy: {
    href: '/help/privacy',
    title: 'Privacy Policy',
    slug: 'privacy-policy',
  },
  providers: {
    href: '/help/providers',
    title: 'Provider Availability Policy',
    slug: 'provider-availability-policy',
  },
  // license: {
  //   href: '/help/licenses',
  //   title: 'License',
  //   slug: 'licenses',
  // },
  gamblingWithResponsibility: {
    href: '/help/gambling-with-responsibility',
    title: 'Gambling With Responsibility',
    slug: 'gambling-with-responsibility',
  },
  selfExclusion: {
    href: '/help/self-exclusion',
    title: 'Self-exclusion Policy',
    slug: 'self-exclusion-policy',
  },
  // sportsBook: {
  //   href: '/help/sportsbook',
  //   title: 'Sportsbook',
  //   slug: 'sportsbook-rules-and-policies',
  // },
  generalBonusesTermsConditions: {
    href: '/help/general-bonuses-terms-conditions',
    title: 'General Bonuses Terms Conditions',
    slug: 'general-bonuses-terms-conditions',
  },
  wagerRequirements: {
    href: '/help/wager-requirement',
    title: 'Wager Requirement',
    slug: 'wager-requirement',
  },
  affiliateTermsAndConditions: {
    href: '/help/affiliate-terms-and-conditions',
    title: 'Affiliate Terms and Conditions',
    slug: 'affiliate-terms-and-conditions',
    i18nSupport: true,
  },
  generalBonusTermsAndCondition: {
    href: '/help/general-bonuses-terms-conditions',
    title: 'General Bonuses Terms & Conditions',
    slug: 'general-bonuses-terms-conditions',
    i18nSupport: false
  },
};

export default helpCenterArticlesConfig;
